module.exports = __webpack_public_path__ + "img/entrance_plant_2@2x.47907e5a.jpg";